const links = document.querySelectorAll( '[data-solutions-links] a' );

links.forEach( link => {
	link.addEventListener( 'click', addSmoothScroll )
} );

function addSmoothScroll( e ) {
	e.preventDefault();
	const href = this.getAttribute( 'href' );
	const offsetTop = document.querySelector( href ).offsetTop;

	scroll( {
		top: offsetTop,
		behavior: 'smooth'
	} );
}
